import * as React from "react";
import { useQuery } from "@apollo/client";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { meQuery } from "../../Me";
import { MeQueryQuery } from "../../../schemaTypes";
import { Spin } from "antd";

export const SessionRoute: React.FC = () => {
  const { data, loading, error } = useQuery<MeQueryQuery>(meQuery);
  const location = useLocation();
  const next = location.pathname + location.search + location.hash;

  if (loading) return <Spin fullscreen style={{ color: "black" }} tip="Loading..." size="large" />;
  if (error) return <div>Error loading session.</div>;

  if (!data) {
    return <Navigate to="/login" replace state={{ next }} />;
  }

  if (data?.me) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};